// Import Asset Images 
import Accordion from "../accordion/accordion";

const AdditionalStatistics = () => {
    return (
        <div className="w-full md:w-[48%] mt-6 md:mt-0">
              <Accordion title='Additional Stats'>
                    <div className="flex justify-between flex-wrap">
                        <div className="border border-[#383838] rounded-lg px-4 py-4 w-[32%] mb-4 min-h-[110px] flex flex-col justify-center items-center">
                            <p className="text-primary text-base font-semibold">2.66</p>
                            <p className="text-sm text-center">Trades Per Week</p>
                        </div>
                        <div className="border border-[#383838] rounded-lg px-4 py-4 w-[32%] mb-4 min-h-[110px] flex flex-col justify-center items-center">
                           <p className="text-primary text-base font-semibold">2.66</p>
                           <p className="text-sm text-center">Trades Per Week</p>
                       </div>
                       <div className="border border-[#383838] rounded-lg px-4 py-4 w-[32%] mb-4 min-h-[110px] flex flex-col justify-center items-center">
                           <p className="text-primary text-base font-semibold">2.66</p>
                           <p className="text-sm text-center">Trades Per Week</p>
                       </div>
                       <div className="border border-[#383838] rounded-lg px-4 py-4 w-[32%] mb-4 min-h-[110px] flex flex-col justify-center items-center">
                           <p className="text-primary text-base font-semibold">2.66</p>
                           <p className="text-sm text-center">Trades Per Week</p>
                       </div>
                       <div className="border border-[#383838] rounded-lg px-4 py-4 w-[32%] mb-4 min-h-[110px] flex flex-col justify-center items-center">
                           <p className="text-primary text-base font-semibold">2.66</p>
                           <p className="text-sm text-center">Trades Per Week</p>
                       </div>
                       <div className="border border-[#383838] rounded-lg px-4 py-4 w-[32%] mb-4 min-h-[110px] flex flex-col justify-center items-center">
                           <p className="text-primary text-base font-semibold">2.66</p>
                           <p className="text-sm text-center">Trades Per Week</p>
                       </div>
                       <div className="border border-[#383838] rounded-lg px-4 py-4 w-[32%] mb-4 min-h-[110px] flex flex-col justify-center items-center">
                           <p className="text-primary text-base font-semibold">2.66</p>
                           <p className="text-sm text-center">Trades Per Week</p>
                       </div>
                       <div className="border border-[#383838] rounded-lg px-4 py-4 w-[32%] mb-4 min-h-[110px] flex flex-col justify-center items-center">
                           <p className="text-primary text-base font-semibold">2.66</p>
                           <p className="text-sm text-center">Trades Per Week</p>
                       </div>
                       <div className="border border-[#383838] rounded-lg px-4 py-4 w-[32%] mb-4 min-h-[110px] flex flex-col justify-center items-center">
                           <p className="text-primary text-base font-semibold">2.66</p>
                           <p className="text-sm text-center">Trades Per Week</p>
                       </div>
                      
                       
                    </div>
              </Accordion>
        </div>
     
    );
}
 
export default AdditionalStatistics;